import React from 'react';
import styled from 'styled-components';
import { Icon, Link, Text } from '@amzn/storm-ui';
import { angleInlineStart } from '@amzn/storm-ui-icons';
import { getClickEventHandler } from 'src/commons/utils';
import type { Breadcrumb as BreadcrumbType } from 'src/app/slice';

const StyledLink = styled(Link)`
  display: flex;
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.xxsmall.mobile} ${theme.spacing.xsmall.mobile}`};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxxsmall.mobile};
  background-color: ${({ theme }) => theme.color.gray[700]};

  && {
    color: ${({ theme }) => theme.text.color.inverted};
  }
`;

const StyledText = styled(Text)`
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & {
    color: ${({ theme }) => theme.text.color.inverted};
  }
`;

interface MobileBreadcrumbProps {
  breadcrumb: BreadcrumbType;
}

const MobileBreadcrumb: React.VFC<MobileBreadcrumbProps> = ({ breadcrumb }) => {
  const eventHandler = getClickEventHandler(breadcrumb);
  const { label, url, objectType } = breadcrumb;
  return (
    <StyledLink href={url} onClick={eventHandler}>
      <Icon type={angleInlineStart} size="xsmall" />
      <StyledText renderAs="span">
        {objectType ? `${objectType}: ${label}` : label}
      </StyledText>
    </StyledLink>
  );
};

export default MobileBreadcrumb;
